import './index.scss'
import Swiper from 'swiper/dist/js/swiper.min.js'

var swiper1 = new Swiper(".news-swiper .swiper", {
  effect : 'fade',
  fadeEffect: {
    crossFade: true,
  },
  on:{
    init:function(){
        let total = this.slides.length > 9 ? this.slides.length : '0'+this.slides.length
        $('.news-swiper .num-cont .total').html(total)
    },
    transitionStart: function(){
      let activeNum = this.realIndex+1
      activeNum = activeNum > 9 ? activeNum : '0'+ activeNum
      $('.news-swiper .num-cont .active-num').html(activeNum)
    },
  }
});